export default __webpack_public_path__ + "static/softwax-5c24633968a0d983f91c6af8796d033b.png";